export interface AuthServiceEntry {
  key: string;
  name: string;
  publicname?: string;
  privatename?: string;
  description?: string;
  domain?: string;
  path?: string;
  icon?: string;
  internal?: boolean | number;
}

export interface BoAuthUser {
  club: string;
  clientName: string;
  role: string;
  email: string;
  firstname: string;
  lastname: string;
  services: AuthServiceEntry[];
}

export interface AuthUser {
  fullName: string;
  email: string;
}

export interface AuthSession {
  token: string;
  user: AuthUser;
  club: string;
  clientName: string;
  tags: string[];
  services: AuthServiceEntry[];
}

export const CURRENT_APP_ID = 'group-sales';

export const CURRENT_SERVICE_KEY = 'groupsales';
